export const styles = (theme) => ({
  '& .MuiIcon-root': {
    width: 64,
    height: '100%',
    color: theme.palette.grey.L30,
    '& .MuiSvgIcon-root': {
      fill: theme.palette.grey.L30,
      width: 'inherit',
      height: 'inherit',
    },
  },

  '& .MuiTypography-root ': {
    color: theme.palette.grey.L30,
    textAlign: 'center',
  },
});
